import { HandheldOptimizationChoice } from "@gamedev-web/one-gaming-crm";

import { TargetPlatform } from "../models/forms";
import { TargetPlatforms } from "../models/targetPlatforms";

export const isHandheldOptimizationSelected = (value: string | undefined): boolean =>
  value === HandheldOptimizationChoice.yes.toString();

export const hasHandheldOptimizationRequiredPlatform = (
  handheldOptimization: string | undefined,
  targetPlatforms: ReadonlyArray<Partial<TargetPlatform>> | undefined
): boolean =>
  !isHandheldOptimizationSelected(handheldOptimization) ||
  targetPlatforms?.some(
    ({ platform, selected, releaseDate }) =>
      platform === TargetPlatforms.windowsStore && selected === true && Boolean(releaseDate?.trim())
  ) === true;
